import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaRegEdit } from "react-icons/fa";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import { useLocation } from "react-router-dom";
// import { HiOutlinePlus } from "react-icons/hi";
import Loading from "../../Student/Reusablecomponents/Loading";
import { HiMiniPlusSmall } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import { FaAnglesLeft } from "react-icons/fa6";

import AddEditHierarchy from "./AddEditHierarchy";
import AddEditHierarchyValues from "./AddEditHierarchyValues";
const InstituteHierarchy = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [Insthierarchy, setInsthierarchy] = useState([]);
  const [InsthierarchyValues, setInsthierarchyValues] = useState([]);
  const [Load, SetLoad] = useState(false);
  const [OpenForm, CloseForm] = useState(false);

const [Hierarchy,SetHierarchy] = useState();

const [SelectHierarchy,SetSelectHierarchy] = useState();
const [AddHValues,SetAddHValues] = useState(false);

  const Instituehierarchy = async () => {
    SetLoad((prev) => !prev);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/NCLAdmin/GetInstituteHierarchy?InstituteId=${location.state.InstId}`,
        {
          headers: { XApiKey: process.env.REACT_APP_XApiKey },
        }
      );
      SetLoad((prev) => !prev);
      setInsthierarchy(response.data);
      InstituehierarchyValues(response.data[0].hierarchyId);
    } catch (error) {
      console.error("Error fetching Institutes data:", error);
      return [];
    }
  };
  const InstituehierarchyValues = async (e) => {
    SetLoad((prev) => !prev);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/NCLAdmin/InstituteHierarchyValues?InstituteId=${location.state.InstId}&HierarchyId=${e}`,
        {
          headers: { XApiKey: process.env.REACT_APP_XApiKey },
        }
      );
      SetLoad((prev) => !prev);
      setInsthierarchyValues(response.data);
      SetSelectHierarchy(response.data[0])
    } catch (error) {
      console.error("Error fetching Institutes data:", error);
      return [];
    }
  };
  useEffect(() => {
    Instituehierarchy();
  }, []);

  console.log("Inst",SelectHierarchy)
  const GethierarchyValues = (e) => {
    const Value = Insthierarchy.filter((item) => item.hierarchy === e);
    InstituehierarchyValues(Value?.[0]?.hierarchyId);
  }
  const BackButton = () => {
    navigate(-1);
  };
  const InsthierarchyColumns = [
    {
      name: "Values",
      selector: "hierarchy",
      sortable: true,
      cell: (Row) => (
        <div
          onClick={() => {GethierarchyValues(Row.hierarchy);SetSelectHierarchy(Row);}}
          title="Click to view Hierarchy values"
          style={{ color: "#4e4eff", cursor: "pointer" }}
        >
          {Row.hierarchy}
        </div>
      ),
    },
    {
      name: "Action",
      cell: (row, rowIndex) => {
        const isLastRow = rowIndex === Insthierarchy.length - 1;
        return (
          <div
            className="dflex"
            style={{ gap: "15px", justifyContent: "center" }}
          >
            <FaRegEdit onClick={()=>SetHierarchy({Edit:true,...row})}
              title="Edit Hierarchy"
              className="CPointer"
              style={{ color: "#624DE3" }}
              size={18}
            />
            {/* {isLastRow && (
              <HiOutlinePlus onClick={()=>SetHierarchy(row)}
                title="Add Hierarchy"
                className="CPointer"
                style={{ color: "#101011ff" }}
                size={18}
              />
            )} */}
          </div>
        );
      },
    },
  ];
  const InsthierarchyValuesCol = [
    {
      name: "Values",
      selector: "hierarchy",
      sortable: true,
    },
    // {
    //   name: "Action",
    //   cell: (row) => (
    //     <div
    //       className="dflex"
    //       style={{ gap: "15px", justifyContent: "center" }}
    //     >
    //       <FaRegEdit
    //         title="Edit"
    //         className="CPointer"
    //         //  onClick={() => {handleEdit(row); }}
    //         style={{ color: "#624DE3" }}
    //         size={18}
    //       />
    //     </div>
    //   ),
    // },
  ]
  return (
    <>
      <div className="TeacherBgImage">

        <div className="MainHeading mt-4">
          Hierarchy Details - {location.state.Instname}
          <div
            className=" Buttons BackNavigation mb-6"
            style={{ float: "left" }}
            onClick={BackButton}
          >
            <FaAnglesLeft /> Back{" "}
          </div>
        </div>
        <DataTable
          data={Insthierarchy}
          columns={InsthierarchyColumns}
          className="NCLDataTable Card mt-3"
          style={{ marginTop: "40px" }}
          Dropdownvalues={["10", "25", "50", "100"]}
          ShowPagination={true}
          ShowPagecount={true}
        />
        {/* <div className="SubHeading mt-4">
         {InsthierarchyValues[0]?.headerValue}
            </div>
            <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <button className="Buttons AddButton">
                        <HiMiniPlusSmall />
                        Add{" "}
                      </button>
                    </div> */}
        <div
          className="SubHeading mt-3"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>{InsthierarchyValues[0]?.headerValue}</div>
          <button className="Buttons AddButton" onClick={()=>SetAddHValues(!AddHValues)} >
            <HiMiniPlusSmall />
            Add
          </button>
        </div>

        <DataTable
          data={InsthierarchyValues}
          columns={InsthierarchyValuesCol}
          className="NCLDataTable Card mt-2"
          style={{ marginTop: "40px" }}
          Dropdownvalues={["10", "25", "50", "100"]}
          ShowPagination={true}
          ShowPagecount={true}
        />
      
      </div>
      {Load && <Loading />}
      {OpenForm && (
        <div className="Model-Open">
          <AddEditHierarchy
            Cancle={CloseForm}
          // EditDetails={EditInstitution}
          // GetList={Institues}
          />
        </div>
      )}


{Hierarchy && <div className="Model-Open">
 <AddEditHierarchy data={Hierarchy} Clear={SetHierarchy} GetList={Instituehierarchy}/>
  </div>}
{AddHValues && <div className="Model-Open">
 <AddEditHierarchyValues AllData ={Insthierarchy} SelectHi={SelectHierarchy} Clear={SetAddHValues} GetIHVList={InstituehierarchyValues}
 InstId={location.state.InstId}
 />
  </div>}
    </>
  );
};
export default InstituteHierarchy